import IGameStates from "./IGameStates";
import { injectable } from "inversify";
import { STATES } from "./states";

@injectable()
export default abstract class AbstractStates implements IGameStates {
	protected stateName: string;
	protected data: any;

	protected promises: Record<string, Promise<any>> = {};
	protected resolves: Record<string, Function> = {};

	protected constructor() {}

	resolve(state: string, data) {
		this.resolves[state](data);
	}

	getState(): string {
		return this.stateName;
	}

	getData() {
		return this.data;
	}

	protected deferState(state) {
		if (this.promises[state]) return this.promises[state];

		let p = new Promise(
			(res) => (this.resolves[state] = this.resolves[state] || res)
		);
		this.promises[state] = p;

		return p;
	}

	abstract beforeSetState();

	async setState(stateName: string, data?, reset = false): Promise<any> {
		this.stateName = stateName;
		this.data = data;

		this.beforeSetState();

		switch (stateName) {
			case STATES.INIT:
				this.stateInit(data);
				break;

			case STATES.LOADED:
				this.stateLoaded(data);
				break;

			case STATES.PREINFO:
				await this.statePreinfo(data);
				break;

			case STATES.SOUND:
				await this.stateSound(data);
				break;

			case STATES.READY:
				this.stateReady(data);
				break;

			case STATES.IDLE:
				this.stateIdle(data);
				return;

			case STATES.FS_IDLE:
				this.stateFsIdle(data);
				return;

			case STATES.SPIN:
				this.stateSpin(data);
				break;

			case STATES.SKIP:
				this.stateSkip(data);
				break;

			case STATES.BONUS:
				this.stateBonus(data);
				break;

			case STATES.BONUS_WHEEL:
				this.stateBonusWheel(data);
				break;

			case STATES.FORCESPIN:
				this.stateForcespin(data);
				break;

			case STATES.BONUS_WIN:
				this.stateBonusWin(data);
				break;

			case STATES.SEARCHING:
				this.stateSearching(data);
				break;

			case STATES.ERROR:
				this.stateError(data);
				break;

			case STATES.JOKER_BONUS_WIN:
				this.stateJokerBonusWin(data);
				break;
		}
	}

	abstract stateBonus(data);

	abstract stateBonusWin(data);

	abstract stateBonusWheel(data);

	abstract stateError(data);

	abstract stateForcespin(data);

	abstract stateIdle(data);

	abstract stateFsIdle(data);

	abstract stateInit(data);

	abstract stateLoaded(data);

	abstract statePreinfo(data);

	abstract stateReady(data);

	abstract stateSkip(data);

	abstract stateSound(data);

	abstract stateSpin(data);

	abstract stateSearching(data);

	abstract stateJokerBonusWin(data);
}
